import SaveButton from "@/components/SaveButton";
import { useRowSelectionCount } from "@/components/data-table/hooks/useRowSelectionCount";

export const ProjectLimitUpsertSaveButton = () => {
  const selectionCount = useRowSelectionCount();
  return <SaveButton disabled={selectionCount > 0 ? false : undefined} />;
};
